import { computed, mergeProps, reactive, toValue, unref } from 'vue';

import { EntityPresenterV2Mode } from '@satellite/composables/presenterV2EntityMode';
import { reactiveOption } from '@satellite/composables/presenterV2ReactiveOption';

import type { ComputedRef, Ref } from 'vue';
import type {
  PresenterV2DisplayConfigOptions,
  PresenterV2DisplayOverrideProps
} from '@satellite/composables/presenterV2DisplayOptions';
import type { YardAreaDetails } from './yardAreaPresenterV2Shared';

export type YardAreaDisplayField = 'name';

export interface UseYardAreaDisplayV2Options extends PresenterV2DisplayConfigOptions {
  nameProps?: PresenterV2DisplayOverrideProps;
}

export function useYardAreaDisplayV2(
  area: Ref<YardAreaDetails | null> | ComputedRef<YardAreaDetails | null>,
  options: UseYardAreaDisplayV2Options = {}
) {
  const displaySize = reactiveOption(options.size, 'regular');
  const displayMode = reactiveOption(options.mode, EntityPresenterV2Mode.Live);
  const isFetchingValue = computed(() => (options.isFetching ? unref(options.isFetching) : false));

  const name = computed(() => area.value?.name ?? null);

  const nameAttrs = computed(() =>
    mergeProps({ 'data-testid': 'yard-area-presenter-area-name' }, toValue(options.nameProps) ?? {})
  );

  return reactive({
    area,
    mode: displayMode,
    size: displaySize,
    isFetching: isFetchingValue,
    name,
    nameAttrs
  });
}

export type YardAreaDisplayV2Data = ReturnType<typeof useYardAreaDisplayV2>;
